import { createContext, useContext } from "react";

// Bot messages typed one after another inside a turn. A message waits in the
// queue until the ones before it are fully typed.
export interface ChatTyping {
  queue: readonly string[];
  enqueue: (id: string) => void;
  dequeue: (id: string) => void;
}

export const ChatTypingContext = createContext<ChatTyping | null>(null);

export const useChatTyping = () => useContext(ChatTypingContext);

// Off when the user asks for less motion, and where there is no layout (tests).
export const canAnimateTyping = () =>
  typeof window.matchMedia === "function" &&
  !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Long enough to read as typing, short enough not to slow the user down.
export const getTypingDelay = (line: unknown) => {
  const length = typeof line === "string" ? line.length : 50;
  return Math.min(Math.max(350 + length * 18, 600), 1600);
};
